class ProductSelector extends HTMLElement {
    constructor() {
        super();
        this.cardHeadings = this.querySelectorAll('.card__heading');
        this.stickyFooter = document.querySelector('.product-cta');
        this.listItems = document.querySelectorAll('li[data-index]');
        this.ATC = this.querySelector('.quick-add__submit');
    }

    connectedCallback() {
        this.makeSelectType();
        this.eventListeners();
    }

    eventListeners() {
        if (this.stickyFooter) {
            const select = this.stickyFooter.querySelector('select');
            if (select) {
                select.addEventListener('change', (e) => {
                    this.updateSelectedRadio(e.target.value);
                });
            }
        }

        this.listItems.forEach((item) => {
            item.addEventListener('click', (e) => {
                const index = e.currentTarget.getAttribute('data-index');
                this.updateSelectedSelect(index);
            });
        });
    }

makeSelectType() {
    const select = document.createElement('select');
    const options = [];

    this.cardHeadings.forEach((heading) => {
        const option = document.createElement('option');
        const parent = heading.closest('.animate--slide-in');
        const dataIndex = parent.getAttribute('data-index');

        option.value = dataIndex;
        option.setAttribute('data-index', dataIndex);
        option.textContent = heading.textContent.trim();

        options.push(option);
    });

    if (options.length > 1) {
        const second = options.splice(1, 1)[0];
        options.unshift(second);
    }

    options.forEach(option => select.appendChild(option));
    select.value=1
    if (this.stickyFooter) {
        this.stickyFooter.querySelector('.section-2').prepend(select);
        const btn = document.createElement('button');
        btn.innerHTML = this.ATC?.innerHTML;
        btn.className = 'quick-add__submit';

        btn.addEventListener('click', () => {
            const active = this.querySelector('li.active-product');
            const realATC = active?.querySelector('.quick-add__submit');
            if (realATC) realATC.click();
        });

        this.stickyFooter.querySelector('#Button').appendChild(btn);
    }
}

    updateSelectedRadio(index) {
        this.listItems.forEach((item) => {
            item.classList.remove('active-product');
        });

        const selectedItem = this.querySelector(`li[data-index="${index}"]`);
        if (selectedItem) {
            selectedItem.classList.add('active-product');
        }
    }

    updateSelectedSelect(index) {
        if (this.stickyFooter) {
            const select = this.stickyFooter.querySelector('select');
            if (select) {
                select.value = index;
            }
        }
    }
}

customElements.define('product-selector', ProductSelector);
